import React, { useLayoutEffect } from 'react';

import { Layout, Typography } from 'antd';

const { Content } = Layout;
const { Title } = Typography;

const PrivacyPolicyPage = () => {
  useLayoutEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const { theme: previousTheme } = document.documentElement.dataset;
    document.documentElement.dataset.theme = 'dark';

    return () => {
      if (previousTheme) {
        document.documentElement.dataset.theme = previousTheme;
        return;
      }

      delete document.documentElement.dataset.theme;
    };
  }, []);

  return (
    <Layout className="legal-page">
      <Content className="legal-page__content">
        <Title level={1} className="legal-page__title">
          Privacy
        </Title>

        <p className="c6">
          <span className="c1">Last Updated June 10, 2026</span>
        </p>
        <p className="c6">
          <span className="c1">
            Welcome to neuralnetworkmarket.com, a data provider platform (the
            &quot;Website&quot;) operated by Neuralnetworkmarket.com., a
            Delaware corporation (&quot;Neuralnetworkmarket&quot;,
            &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;). The Website
            enables users of the Website (&quot;Users&quot;) to learn more about
            us and use certain of our baseline Products offered for free through
            the Website and allow Users who purchase a subscription
            (&quot;Subscribers&quot;) to download and use certain additional of
            our APIs, SDKs, code snippets and other of our data products
            (collectively, the &quot;Products&quot;) offered through the Website
            (collectively the Website and Products are referred to as the
            &quot;Services&quot;). The term &quot;you&quot; and &quot;your&quot;
            shall refer to Users and/or Subscribers, as applicable.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            This Privacy Policy (&quot;Privacy Policy&quot;) is designed to help
            you, whether as a User or Subscriber, understand how we collect, use
            and share your personal information when you use our Services, and
            to assist you in understanding the applicable privacy rights
            available to you. By using the Website, you agree to the collection
            and use of your personal information and other information by
            Neuralnetworkmarket as described in this Privacy Policy.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            What type of personal information does Neuralnetworkmarket collect
            from you and how do we use it?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            We may collect certain information automatically when you use the
            Services. This information may include your Internet protocol (IP)
            address, user settings, MAC address, cookie identifiers, mobile
            carrier, mobile advertising and other unique identifiers, details
            about your browser, operating system or device, location
            information, Internet service provider, pages that you visit before,
            during and after using the Services, information about the links you
            click, and other information about how you use the Services.
            Information we collect may be associated with accounts and other
            devices.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            In addition, subscribers must provide personal information to
            Neuralnetworkmarket in order to register with us and use our
            Products, including without limitation a Subscriber&#39;s name,
            address, email, phone number, time zone, role and payment
            information (if a purchase is being made).
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            We intend to use all such information collected through the Services
            for multiple purposes, including without limitation to keep you
            informed about our activities by sending you emails or by reaching
            you by phone. We may also ask you for general statistical,
            non-personal information about yourself and your interests. We may
            also use de-identified and aggregate information for promotional and
            other business purposes.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            How else do we use your personal information?
          </span>
        </p>
        <p className="c6">
          <span className="c11">Neuralnetworkmarket</span>
          <span className="c1">
            &nbsp;or entities working on our behalf may use your personal
            information to help fulfill your requests in connection with your
            use of the Services, or to help us or third parties communicate with
            you about different resources offered as part of the Services, or
            otherwise. For example, we may transfer information collected at
            registration, including your personal information, to service
            providers and other third parties who assist us in running the
            Services, including without limitation in connection with analytics,
            authorization and billing.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            Under what other circumstances may we share your personal
            information?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            In addition to sharing your personal information with third parties
            as described above, we may also release your personal information to
            other third parties if we believe that such release is necessary (a)
            to comply with the law (e.g., a legal process or a statutory or
            regulatory authorization or requirement) or a court order, (b) in
            order to apply or enforce the Terms of Use or otherwise protect our
            interests, (c) in order to protect you, other Users or Subscribers,
            or us from fraudulent, abusive, or unlawful use of the Services or
            from other harm, or (d) if we reasonably believe that a danger to
            any person or property requires the disclosure of such personal
            information.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            Our rights under this Privacy Policy may be automatically assigned
            by Neuralnetworkmarket, in our sole discretion, to a third party or
            parties, and such an assignment will inure to the benefit of our
            successors, assigns and/or licensees. Without limitation of the
            foregoing, we may sell, transfer or otherwise share some or all of
            our assets, including without limitation your personal information,
            with any parent company, subsidiary, joint venture, and/or any
            company under our common control, as well as to a potential acquirer
            and/or an acquirer, including without limitation in connection with
            a merger, reorganization, or sale of assets or stock, or in the
            event of a bankruptcy. In each such an event, the personal
            information we have collected from you may be one of the assets
            transferred in connection with any such a transaction or event.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            What other information does Neuralnetworkmarket collect through the
            Services?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            We may also collect personal information from you about your
            preferences in navigating the Website or otherwise using the
            Services by using cookies, action tags and other technologies.
            Cookies are small text files that identify your computer and can
            track your behavior across multiple platforms. We may use cookies
            to, among other things, monitor usage of the Website, customize
            features of the Website, identify your computer&#39;s or other
            device&#39;s operating system and browser, and complete
            transactions. An action tag is a small, graphic image on a webpage
            that is designed to allow the website owner or a third party to
            monitor who is visiting a website by collecting the IP address of
            the computer to which the tag is sent, the URL of the webpage that
            the tag comes from and the time at which such webpage was viewed.
            Action tags may be associated with cookie information.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            Can I restrict the use of cookies on the Services?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            &nbsp;You may stop or restrict the placement of cookies and other
            technologies on your device or remove them by adjusting your
            preferences as your browser or device permits. The online
            advertising industry also provides websites from which you may opt
            out of receiving targeted ads from data partners and other
            advertising partners that participate in self-regulatory programs.
            You can access these websites and learn more about targeted
            advertising and consumer choice and privacy, at
            www.networkadvertising.org/managing/opt_out.asp,
            http://www.youronlinechoices.eu/, https://youradchoices.ca/choices/,
            and www.aboutads.info/choices/. To separately make choices for
            mobile apps on a mobile device, you can download DAA&rsquo;s
            AppChoices application from your device&rsquo;s app store.
            Alternatively, for some devices you may use your device&rsquo;s
            platform controls in your settings to exercise choice.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            Please note you must separately opt out in each browser and on each
            device. Advertisements on third party websites that contain the
            AdChoices link may have been directed to you based on information
            collected by advertising partners over time and across websites.
            These advertisements provide a mechanism to opt out of the
            advertising partners&rsquo; use of this information for
            interest-based advertising purposes.
          </span>
        </p>
        <p className="c6">
          <span className="c2 c3">Security</span>
        </p>
        <p className="c6">
          <span className="c11">Neuralnetworkmarket</span>
          <span className="c1">
            &nbsp;takes steps consistent with commercially reasonable industry
            standards to secure personal information collected from you from
            loss, misuse, unauthorized access and destruction while under our
            control. However, please note that despite our efforts to protect
            information provided to us, we cannot guarantee that such
            information will not be lost, disclosed or accessed by accidental
            circumstances or by the unauthorized acts of others.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            Does Neuralnetworkmarket provide links to other websites?
          </span>
        </p>
        <p className="c6">
          <span className="c11">Neuralnetworkmarket</span>
          <span className="c1">
            &nbsp;may provide links to other websites or resources of possible
            interest to you, and you may provide information to or engage in
            relationships with third parties by using the Services. The
            collection and use of your personal information and other
            information by such websites or otherwise by such third parties
            shall be subject to the policies and procedures of such websites and
            not those contained in this Privacy Policy. The information
            collected by our service providers or other third parties working on
            our behalf, including without limitation credit card settlement
            companies, in consummating purchases you may have made through the
            Services or otherwise in the course of assisting us, is subject to
            the privacy policies of such third parties and is not subject to
            this Privacy Policy.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            What are our policies regarding children?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            The Website is intended for general use by persons who have reached
            the age of consent in their state of residence and it is not
            targeted to anyone under thirteen (18) years of age.
            Neuralnetworkmarket does not knowingly collect personal information
            from anyone under thirteen (18) years of age. If we learn that we
            have unintentionally collected personal information from anyone
            under thirteen (18) years of age, we will promptly delete such
            information.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">Do we respond to Do Not Track Signals?</span>
        </p>
        <p className="c6">
          <span className="c1">
            The Website does not have the capability to respond to &quot;Do Not
            Track&quot; signals received from various web browsers.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            How can the terms of this Privacy Policy be modified?
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            We reserve the right to change how we handle and use the information
            that we collect through the Services, and to modify this Privacy
            Policy at any time in our sole discretion. You agree to review this
            Privacy Policy periodically to be aware of all such modifications.
            You further agree that your continued use of the Services after a
            modified version of this Privacy Policy has been posted shall be
            deemed to be your conclusive acceptance of any modified version of
            this Privacy Policy. We will indicate that changes to this Privacy
            Policy have been made by updating the date indicated after the
            &quot;Last Modified&quot; indicator at the beginning of this Privacy
            Policy. If you do not agree to abide by the initial version and each
            modified version of this Privacy Policy, as applicable, then you are
            not authorized to use the Services. A current version of this
            Privacy Policy is accessible via the footer of the Website&#39;s
            homepage.{' '}
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">
            What are Your California Privacy Rights?{' '}
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            California&rsquo;s &quot;Shine the Light&quot; law (Civil Code
            Section &sect; 1798.83) permits Users who are California residents
            to request certain information regarding our disclosure of personal
            information to third parties for their direct marketing purposes. To
            make such a request, please contact us using the contact information
            provided below in this Privacy Policy.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            The California Consumer Privacy Act (&quot;CCPA&quot;) grants
            certain rights to California consumers. Depending upon your location
            and in accordance with applicable laws, you may have the right to:
          </span>
        </p>
        <p className="c6">
          <span className="c2">Access</span>
          <span className="c1">
            &nbsp;personal information about you consistent with legal
            requirements. In addition, you may have the right in some cases to
            receive or have your electronic personal information transferred to
            another party.
          </span>
        </p>
        <p className="c6">
          <span className="c2">Request Deletion</span>
          <span className="c1">
            &nbsp;of your personal information, subject to certain exceptions
            prescribed by law.
          </span>
        </p>
        <p className="c6">
          <span className="c2">Opt or opt out of the sale</span>
          <span className="c1">
            &nbsp;of your personal information to third parties. Please note we
            do not sell your personal information.
          </span>
        </p>
        <p className="c6">
          <span className="c2">Not be Discriminated Against</span>
          <span className="c1">
            &nbsp;by us for exercising your privacy rights.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            If you wish to delete personal information that you have submitted
            to Neuralnetworkmarket, please send us an email requesting such
            removal (with the word &quot;Removal&quot; in the email subject
            line) to legal@Neuralnetworkmarket.io. If you would like to exercise
            any of the other rights, please contact us as set forth below. We
            will process such requests in accordance with applicable laws. To
            protect your privacy, we will take steps to verify your identity
            before fulfilling your request.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            For purposes of the CCPA, we have collected the following categories
            of consumers&rsquo; personal information in the last 12 months:
          </span>
        </p>
        <table className="c20">
          <tr className="c29">
            <td className="c21" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c2">Category</span>
              </p>
            </td>
            <td className="c7" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c2">Examples</span>
              </p>
            </td>
            <td className="c28" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c2">Collected</span>
              </p>
            </td>
          </tr>
          <tr className="c26">
            <td className="c30" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Identifiers.</span>
              </p>
            </td>
            <td className="c13" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  name, alias, postal address, unique personal identifier,
                  online identifier, Internet Protocol address, email address,
                  account name, Social Security, or other similar identifiers.
                </span>
              </p>
            </td>
            <td className="c27" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Yes</span>
              </p>
            </td>
          </tr>
          <tr className="c19">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Protected classification characteristics under California or
                  federal law.
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Age (40 years or older), race, color, ancestry, national
                  origin, citizenship, religion or creed, marital status,
                  medical condition, physical or mental disability, sex
                  (including gender, gender identity, gender expression,
                  pregnancy or childbirth and related medical conditions),
                  sexual orientation, veteran or military status, genetic
                  information (including familial genetic information).
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c10">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Commercial information.</span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Records of personal property, products or services purchased,
                  obtained, or considered, or other purchasing or consuming
                  histories or tendencies.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Yes</span>
              </p>
            </td>
          </tr>
          <tr className="c32">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Biometric information.</span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Physiological, biological, or behavioral, characteristics
                  (including DNA) that can be used to establish individual
                  identity, or imagery of the iris, retina, fingerprint, face,
                  hand, palm, vein patterns, and voice recordings, from which an
                  identifier template such as a faceprint, a minutiae template,
                  or a voiceprint, can be extracted and keystroke patterns or
                  rhythms, gait patterns, or rhythms, and sleep, health or
                  exercise data that contain identifying information.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c17">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Internet or other electronic network activity.
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Browsing history, search history, information on a
                  consumer&#39;s interaction with an internet website,
                  application, or advertisement.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Yes</span>
              </p>
            </td>
          </tr>
          <tr className="c18">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Geolocation data.</span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Physical location or movements.</span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c24">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Sensory data.</span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Audio, electronic, visual, thermal, olfactory, or similar
                  information.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c25">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Professional or employment-related information.
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Current or past job history or performance evaluations.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Non-public education information (per the Family Educational
                  Rights and Privacy Act (20 U.S.C. Sec. 1232g, 34 C.F.R. Part
                  99)).
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Education records directly related to a student maintained by
                  an educational institution or party acting on its behalf, such
                  as grades, transcripts, className lists, student schedules,
                  student identification codes, student financial information,
                  or student disciplinary records.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c10">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Inferences drawn from other personal information to create a
                  profile about a consumer.
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Profile reflecting a consumer&#39;s preferences,
                  characteristics, psychological trends, predispositions,
                  behavior, attitudes, intelligence, abilities, and aptitudes.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">No</span>
              </p>
            </td>
          </tr>
          <tr className="c23">
            <td className="c9" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  Personal information categories listed in the categories
                  above, but references in the California Customer Records
                  statute (Cal. Civ. Code &sect; 1798.80(e)).
                </span>
              </p>
            </td>
            <td className="c5" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">
                  A name, signature, Social Security number, physical
                  characteristics or description, address, telephone number,
                  passport number, driver&#39;s license or state identification
                  card number, insurance policy number, education, employment,
                  employment history, bank account number, credit card number,
                  debit card number, or any other financial information, medical
                  information, or health insurance information. Personal
                  Information does not include publicly available information
                  that is lawfully made available to the general public from
                  federal, state, or local government records. Note: Some
                  personal information included in this category may overlap
                  with other categories.
                </span>
              </p>
            </td>
            <td className="c14" colSpan={1} rowSpan={1}>
              <p className="c4">
                <span className="c1">Yes</span>
              </p>
            </td>
          </tr>
        </table>
        <p className="c6">
          <span className="c1">&nbsp;</span>
        </p>
        <p className="c6">
          <span className="c1">
            We use the collected personal information for the following
            commercial and business purposes: (1) to provide and improve the
            Services; (2) for marketing purposes; (3) for fraud prevention and
            legal purposes; (4) to secure the Services; and (5) for audit
            purposes.
          </span>
        </p>
        <p className="c6">
          <span className="c1">
            Personal information within each of the categories may be shared
            with the following categories of third parties: (1) service
            providers; (2) business partners; (3) advertising partners; and (4)
            other users. The categories of personal information are shared for
            the commercial and business purposes listed above.
          </span>
        </p>
        <p className="c6">
          <span className="c3 c2">Contacts us</span>
        </p>
        <p className="c6">
          <span className="c11">
            If you have questions or concerns about any of our information
            collection or handling practices, please contact us at
            legal@Neuralnetworkmarket.com
          </span>
        </p>
        <p className="c4 c22">
          <span className="c3 c12"></span>
        </p>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicyPage;
